<div class="ttmodal">
    <div class="ttmodal__header">
      <span class="ttmodal__title">{{ editing ? 'Editing Customer Notes':'Add New Customer Notes' | translate | async}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
    </div>
    <div class="ttmodal__body">
      <div *ngIf="!editing">
        <mat-form-field class="customer-notes-select" >
            <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="selectedCustomer"  placeholder="{{'Select Customer' | translate | async}}"  [formControl]="customerSelectionControl">
                <mat-option *ngFor="let customer of selectionLists.customerList" [value]="customer">
                  {{ customer.Title }}
                </mat-option>
              </mat-select>
        </mat-form-field>
        <div *ngIf="customerSelectionControl.errors && (customerSelectionControl.dirty || customerSelectionControl.touched)" style="margin-bottom: 20px;">
            <mat-error *ngIf="customerSelectionControl.errors.required">{{'Need To Address at least one customer'| translate | async}}</mat-error>
        </div>
      </div>

      <div *ngIf="editing" style="font-weight: 500; font-size: 18px;">
        {{'Address This Customer Note to' | translate | async}} :
        <div style="margin-left: 100px;">{{newModel.AddressToCustomerName}}</div>
      </div>

      <div>
        <mat-form-field class="customer-notes-input">
            <textarea rows="6" matInput placeholder="Notes" [(ngModel)]="newModel.Note" [formControl]="notesControl"></textarea>
        </mat-form-field>
      </div>
      <div *ngIf="notesControl.errors && (notesControl.dirty || notesControl.touched)" style="margin-bottom: 20px;">
          <mat-error *ngIf="notesControl.errors.required">{{'Notes Content is Required'| translate | async}}</mat-error>
      </div>
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="SaveCustomerNote()" [disabled]= "notesControl.errors || customerSelectionControl.errors">
        <span class="material-icons button__icon">check</span>
        <span class="button__text">{{ editing ? 'Save' : 'Add New Customer Notes' | translate | async}}</span>
      </button>
    </div>
  </div>
